<template>
  <div id="dash">
    <!-- <dash-hidden /> -->
    <dash-header
      :logoMini="app.logoMini"
      :header="app.header"
      :subHeader="app.subHeader"
      :version="app.version"
      :currentUser="app.currentUser"
      :nowLang="app.nowLang"
      :toggleControlsidebar="toggleControlsidebar"
      :controlsidebarDisp="controlsidebarDisp"
      :postLogout="app.postLogout"
      :headerNotiAnnounceTotal="headerNotiAnnounceTotal"
      :headerNotiAnnounceInfiniteLoading="headerNotiAnnounceInfiniteLoading"
      :headerNotiRequestTotal="headerNotiRequestTotal"
      :headerNotiRequestInfiniteLoading="headerNotiRequestInfiniteLoading"
      :headerNotiApprove="headerNotiApprove"
      :receivedHeaderNotiRequestInfiniteLoading="receivedHeaderNotiRequestInfiniteLoading"
      :receivedHeaderNotiAnnounceInfiniteLoading="receivedHeaderNotiAnnounceInfiniteLoading"
      :toggleSidebar="toggleSidebar"
      :pcDisp="app.pcDisp"
      :closeSidebarMobile="closeSidebarMobile"
      :profileimg="profileimg"
      :allLang="app.allLang"
      :focusLang="app.focusLang"
      :setLang="app.setLang" />
    <dash-sidebar
      :fontIcon="app.fontIcon"
      :currModule="currModule"
      :currCodapp="currCodapp"
      :version="app.version"
      :currentUser="app.currentUser"
      :nowLang="app.nowLang"
      :modules="modules"
      :mainMenu="app.mainMenu"
      :menuRequest="app.menuRequest"
      :menuApprove="app.menuApprove"
      :menu="app.menu"
      :rescale="rescale"
      :closeControlsidebar="closeControlsidebar"
      :controlsidebarDisp="controlsidebarDisp"
      :pcDisp="app.pcDisp"
      :closeSidebarMobile="closeSidebarMobile"
      :profileimg="profileimg" />
    <dash-body
      :fontIcon="app.fontIcon"
      :currModule="currModule"
      :currCodapp="currCodapp"
      :nameModule="nameModule"
      :descCodapp="descCodapp"
      :codapp="codapp"
      :descModule="descModule"
      :closeControlsidebar="closeControlsidebar"
      :controlsidebarDisp="controlsidebarDisp"
      :pcDisp="app.pcDisp"
      :closeSidebarMobile="closeSidebarMobile" />
    <dash-footer
      :version="app.version" />
    <dash-controlsidebar
      :nowLang="app.nowLang"
      :allLang="app.allLang"
      :focusLang="app.focusLang"
      :setLang="app.setLang"
      :postLogout="app.postLogout"
      :controlsidebarDisp="controlsidebarDisp"
      :toggleControlsidebar="toggleControlsidebar"
      :mailLang="mailLang"
      :postControlsidebarMailLang="postControlsidebarMailLang" />
  </div>
</template>

<script>
import DashHidden from 'components/dash/DashHidden'
import DashHeader from 'components/dash/DashHeader'
import DashSidebar from 'components/dash/DashSidebar'
import DashBody from 'components/dash/DashBody'
import DashFooter from 'components/dash/DashFooter'
import DashControlsidebar from 'components/dash/DashControlsidebar'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/dash/mutation-types'
import * as profileimgTypes from 'store/modules/profileimg/mutation-types'
import $ from 'jquery'

export default {
  name: 'dash',
  data () {
    return {
      app: this.$parent,
      descLang: ['English', 'Thai'],
      // colorSkins: ['blue', 'teal', 'aqua', 'olive', 'green', 'purple', 'fuchsia', 'maroon', 'red', 'orange', 'yellow', 'gold', 'brown', 'black', 'navy'],
      colorSkins: ['blue', 'green', 'orange', 'red', 'purple', 'black'],
      colorLeftSidebarDark: '#222d32',
      colorBodySidebarDark: '#f4f5f7',
      colorLeftSidebarLight: '#f9fafc',
      colorBodySidebarLight: '#f4f5f7',
      sidebarDisp: false
    }
  },
  created () {
    this.receivedModules()
    this.receivedHeaderNotiTotal('P,Y,N,A')
    this.receivedTinitial()
    this.receivedTfolder()
    this.rescale()
    this.setCurrPath(this.$route.fullPath.split('/')[1])
    this.hideModal()
    this.receivedControlsidebarMailLang()
    let _this = this
    $(document).on('click', '.btn-lov', function () {
      _this.openModal()
    })
    $(document).on('click', '.fa.close', function () {
      _this.hideModal()
    })
    $(document).on('click', '.button-in-td.button-select-item i', function () {
      _this.hideModal()
      if ($('.modal').hasClass('in')) {
        _this.openModal()
      }
    })
    $(document).on('click', '.logical-wrapper .fa.close', function () {
      _this.openModal()
    })
    $(document).on('click', '.logical-wrapper .button-in-td i', function () {
      _this.openModal()
    })
    $(document).on('click', '.modal-body .modal-header .fa.close', function () {
      _this.openModal()
    })
    $(document).on('click', '.modal .hrms-searchbox-table .modal-header .fa.close', function () {
      _this.openModal()
    })
    $(document).on('keydown', 'input[type="number"]', function (event) {
      return !(event.keyCode === 69)
    })
  },
  watch: {
    $route () {
      this.setCurrPath(this.$route.fullPath.split('/')[1])
      this.hideModal()
    },
    modules () {
      this.setCurrPath(this.$route.fullPath.split('/')[1])
    }
  },
  computed: {
    codapp () {
      return this.currCodapp.toUpperCase().replace(this.productionSite, '')
    },
    module () {
      return this.modules[this.currModule]
    },
    nameModule () {
      if (typeof this.module !== 'undefined') {
        if (typeof this.module['name'] !== 'undefined') {
          return this.module['name'][this.app.nowLang]
        }
      }
      return ''
    },
    descModule () {
      if (typeof this.module === 'undefined') {
        return ''
      } else {
        return this.module['desc']
      }
    },
    descCodapp () {
      if (typeof this.module === 'undefined') {
        return ''
      } else {
        if (typeof this.module['codapp_permis'] !== 'undefined') {
          if (typeof this.module['codapp_permis'][this.currCodapp] !== 'undefined') {
            return this.module['codapp_permis'][this.currCodapp][this.app.nowLang]
          } else {
            return ''
          }
        } else {
          return ''
        }
      }
    },
    productionSite () {
      return this.app.baseConn.user.replace('ESS', '').toUpperCase()
    },
    ...mapGetters({
      tinitial: types.GET_TINITIAL,
      tfolder: types.GET_TFOLDER,
      currModule: types.GET_CURR_MODULE,
      currCodapp: types.GET_CURR_CODAPP,
      controlsidebarDisp: types.GET_CONTROLSIDEBAR_DISP,
      modules: types.GET_MODULES,
      headerNotiAnnounceTotal: types.GET_HEADER_ANNOUNCE_TOTAL,
      headerNotiAnnounceInfiniteLoading: types.GET_HEADER_ANNOUNCE_INFINITE_LOADING,
      headerNotiRequestTotal: types.GET_HEADER_REQUEST_TOTAL,
      headerNotiRequestInfiniteLoading: types.GET_HEADER_REQUEST_INFINITE_LOADING,
      headerNotiApprove: types.GET_HEADER_APPROVE,
      profileimg: profileimgTypes.GET_PROFILEIMG_FILEPATH,
      mailLang: types.GET_CONTROLSIDEBAR_MAIL_LANG
    })
  },
  methods: {
    openModal () {
      $('body').addClass('modal-open')
    },
    hideModal () {
      $('body').removeClass('modal-open')
      $('.modal-backdrop').remove()
    },
    getTinitial () {
      let routeName = this.$route.name
      let tinitialRowsFiltered = this.tinitial.rows.filter(tinitialRow => {
        return tinitialRow.codapp.toLowerCase() === routeName.toLowerCase()
      })
      let obj = {
        codapp: '',
        en: {},
        th: {}
      }
      obj.codapp = routeName
      for (let tinitialRowFiltered of tinitialRowsFiltered) {
        obj.en[tinitialRowFiltered.numseq] = tinitialRowFiltered.datainit1
        obj.th[tinitialRowFiltered.numseq] = tinitialRowFiltered.datainit2
      }
      return obj
    },
    getTfolder () {
      let routeName = this.$route.name
      let tfolderRowsFiltered = this.tfolder.rows.filter(tfolderRow => {
        return tfolderRow.codapp.toLowerCase() === routeName.toLowerCase()
      })
      let obj = {
        main: '',
        temp: this.tfolder.rows[0].temp,
        load: this.tfolder.rows[0].load,
        codapp: '',
        folder: ''
      }
      for (let tfolderRowFiltered of tfolderRowsFiltered) {
        obj = tfolderRowFiltered
      }
      return obj
    },
    getTfolderNoFilter () {
      return this.tfolder.rows
    },
    rescale () {
      this.$nextTick(function () {
        $('.content-wrapper').css({ minHeight: $('.main-sidebar').height() + 30 })
      })
    },
    toggleSidebar () {
      if (this.app.pcDisp) {
        if ($('body').hasClass('sidebar-collapse')) {
          $('body').removeClass('sidebar-collapse')
        } else {
          $('body').addClass('sidebar-collapse')
        }
      } else {
        if ($('body').hasClass('sidebar-open')) {
          $('body').removeClass('sidebar-open sidebar-collapse')
        } else {
          $('body').addClass('sidebar-open')
        }
      }
    },
    closeSidebarMobile () {
      if (!this.app.pcDisp) {
        this.closeSidebar()
      }
    },
    closeSidebar () {
      if (this.app.pcDisp) {
        $('body').removeClass('sidebar-open').addClass('sidebar-collapse')
      } else {
        $('body').removeClass('sidebar-open sidebar-collapse')
      }
    },
    ...mapMutations({
      setCurrPath: types.SET_CURR_PATH,
      toggleControlsidebar: types.SET_CONTROLSIDEBAR_DISP,
      closeControlsidebar: types.SET_CONTROLSIDEBAR_DISP_FALSE
    }),
    ...mapActions({
      receivedTinitial: types.RECEIVED_TINITIAL,
      receivedTfolder: types.RECEIVED_TFOLDER,
      receivedModules: types.RECEIVED_MODULES,
      receivedHeaderNotiTotal: types.RECEIVED_HEADER_NOTI_TOTAL,
      receivedHeaderNotiAnnounceInfiniteLoading: types.RECEIVED_HEADER_ANNOUNCE_INFINITE_LOADING,
      receivedHeaderNotiRequestInfiniteLoading: types.RECEIVED_HEADER_REQUEST_INFINITE_LOADING,
      receivedControlsidebarMailLang: types.RECEIVED_CONTROLSIDEBAR_MAIL_LANG,
      postControlsidebarMailLang: types.POST_CONTROLSIDEBAR_MAIL_LANG
    })
  },
  components: {
    DashHidden,
    DashHeader,
    DashSidebar,
    DashBody,
    DashFooter,
    DashControlsidebar
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?323b05b3